import Carousel from 'react-bootstrap/Carousel';

function MainCarousel({ imgArr }) {
    console.log(imgArr)
    return (
        <Carousel fade>
            {imgArr.map(item =>
                <Carousel.Item>
                    <a href={item.link}>
                        <img
                            className="d-block w-100"
                            src={item.src}
                            href={item.link}
                            alt="First slide"
                        />
                    </a>
                </Carousel.Item>
            )}
        </Carousel>
    );
}

export default MainCarousel;